import moment from "moment";
import { findLast, isEqual } from "lodash";

export const containerStyle = {
  width: '100%',
  height: '500px'
};

export const center = {
  lat: 52.2220994, lng: 5.3098101
};
export const styles = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#EDEDED"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#bdbdbd"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dadada"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#c9c9c9"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  }
];
export const radiuses = [
  {
    value: 0,
    text: "Afstand",
  },
  {
    value: 10,
    text: "10km"
  },
  {
    value: 20,
    text: "20km"
  },
  {
    value: 30,
    text: "30km"
  },
  {
    value: 40,
    text: "40km"
  },
  {
    value: 50,
    text: "50km"
  },
  {
    value: 100,
    text: "100km"
  }
];
export function convertTime(schedule) {
  const grossierSchedule = schedule;

  // convert all times into a moment object
  const week = Object.keys(grossierSchedule).map(key => {
    const day = grossierSchedule[key];
    day.value = day.value.map(time => {
      return {
        start: moment(time.start).format('HH:mm'),
        end: moment(time.end).format('HH:mm'),
      }
    })

    return day;
  })

  // Mark all duplicates
  week.forEach((day, index, self) => {
    const duplicate = self.findIndex((t) => isEqual(t.value, day.value));

    if (index !== duplicate) {
      // check if theres day inbetween which doesnt have the same time
      if ( (index - 1) === duplicate || week[index - 1] && week[index - 1].inherits !== undefined) {
        week[index].inherits = duplicate;
      }
    }
  })

  const daysWithInherits = week.filter(i => i.inherits !== undefined).filter((day, index, self) => {
    const duplicate = self.findIndex((t) => isEqual(t.value, day.value));
    return index === duplicate
  })

  daysWithInherits.forEach(uniqueDay => {
    const isLast = findLast(week, (item) => item.inherits === uniqueDay.inherits);
    week[isLast.inherits].name = `${week[isLast.inherits].name} t/m ${isLast.name}`;
  })


  return week.filter(t => t.inherits === undefined);
}


export function sortGrossier(a, b) {
  if (a.distance !== undefined && b.distance !== undefined) {
    if (a.distance <  b.distance) {
      return -1;
    }

    if (a.distance > b.distance) {
      return 1;
    }

    return 0;
  }

  const nameA = a.title.toUpperCase();
  const nameB = b.title.toUpperCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;
}
